import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — scroll the window to (0,0) on every route change so a SPA
 * Link click never inherits the previous page's scroll position. This fixes
 * the "I clicked a footer link and the new page opened scrolled to the
 * bottom" class of bugs.
 *
 * - Skips when the URL has a hash (#anchor) so in-page anchors still work.
 * - Skips when the navigation includes a query change but pathname is the
 *   same (so filter changes on /archive don't jerk the page to the top).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
